import React, { forwardRef } from 'react';

import { NumericFormat } from 'react-number-format';

import type { NumberFormatValues } from 'react-number-format';

type NumberFormatCustomProps = {
  onChange: (event: { target: { value: number | null } }) => void;
  alwaysNegative?: boolean;
  alwaysPositive?: boolean;
  [x: string]: any;
};

// eslint-disable-next-line
const NumberFormatCustom = forwardRef<HTMLHeadingElement, NumberFormatCustomProps>((props, ref) => {
  const { onChange, alwaysNegative, alwaysPositive, ...args } = props;
  return (
    <NumericFormat
      {...args}
      onValueChange={(value: NumberFormatValues) => {
        let newValue: number | null =
          value.floatValue === undefined || value.floatValue === 0 ? 0 : value.floatValue;
        if (alwaysNegative) {
          newValue = newValue === 0 ? 0 : -Math.abs(newValue) * 100;
        } else if (alwaysPositive) {
          newValue = newValue === 0 ? 0 : Math.abs(newValue) * 100;
        } else {
          newValue = newValue ? newValue * 100 : null;
        }

        onChange({
          target: {
            value: newValue,
          },
        });
      }}
      decimalScale={2}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalSeparator="."
      isAllowed={(values) => {
        const { floatValue } = values;

        if (alwaysPositive) {
          return floatValue === undefined || floatValue >= 0;
        }
        return true;
      }}
    />
  );
});

export default NumberFormatCustom;
